<div class="custom-code-dialog">
  <div class="custom-code-dialog__header">
    <pdq-heading element="h5">Custom Code</pdq-heading>
    <div class="custom-code-dialog__header-actions">
      @if (variables.length > 0) {
        <div class="custom-code-dialog__variable-library-anchor">
          <pdq-button variant="secondary" size="medium" (onClick)="toggleVariableLibrary()"
            >Variable library</pdq-button
          >
          @if (isVariableLibraryOpen) {
            <div class="variable-library">
              @for (variable of variables; track variable.reference) {
                <div class="variable-library__row" (click)="copyVariable(variable.reference)">
                  <div class="variable-library__info">
                    <div class="variable-library__title">
                      <span class="variable-library__name">{{ variable.reference }}</span>
                      <span class="variable-library__type">{{ variable.type }}</span>
                    </div>
                    <div class="variable-library__description">{{ variable.description }}</div>
                  </div>
                  <img class="variable-library__copy" src="/assets/icons/copy.svg" alt="Copy" />
                </div>
              }
            </div>
          }
        </div>
      }
      <pdq-button variant="ghost" plain="true" icon="close" size="small" (onClick)="cancel()"></pdq-button>
    </div>
  </div>
  <pdq-divider></pdq-divider>

  <div class="custom-code-dialog__body">
    <pdq-monaco-editor
      [language]="language"
      [value]="codeControl.value"
      (valueChange)="onCodeChange($event)"></pdq-monaco-editor>
  </div>

  @if (templateParseError) {
    <div class="custom-code-dialog__parse-error">
      <span class="custom-code-dialog__parse-error-title"
        >This template has a syntax error and was not saved{{ templateParseErrorLocationLabel }}</span
      >
      <pre class="custom-code-dialog__parse-error-detail">{{ templateParseError.message }}</pre>
    </div>
  }

  <pdq-divider></pdq-divider>
  <div class="custom-code-dialog__footer">
    <div class="custom-code-dialog__footer-restore-actions">
      @if (defaultCode) {
        <pdq-button
          label="Reset to default"
          icon="sync"
          variant="ghost"
          plain="true"
          size="medium"
          iconColor="var(--secondary-default)"
          labelColor="var(--secondary-default)"
          (onClick)="resetToDefault()"></pdq-button>
      }
      @if (canRevertToPreviousVersion) {
        <pdq-button
          label="Revert to last saved"
          variant="ghost"
          plain="true"
          size="medium"
          labelColor="var(--secondary-default)"
          (onClick)="revertToPreviousVersion()"></pdq-button>
      }
    </div>
    <pdq-button variant="secondary" (onClick)="cancel()">Cancel</pdq-button>
    <pdq-button variant="primary" (onClick)="save()">Save</pdq-button>
  </div>
</div>
